<div class="mater-suite-title">
  <h1 class="title">{{ this.dataDialog.masterSuiteName }}</h1>
  @if (isLoading) {
    <mat-spinner class="spinner"></mat-spinner>
  }
</div>
<mat-dialog-content class="mater-suite-model">
  @if (!isLoading) {
    <mat-radio-group
      aria-label="Select an option"
      [(ngModel)]="enhancementVariantSelected"
      >
      @for (enhancementVariant of enhancementVariants; track enhancementVariant; let i = $index) {
        <div
          class="mater-suite-item"
          >
          <mat-radio-button [value]="enhancementVariant"
            >{{ enhancementVariant.name }}
            {{ enhancementVariant.default ? " (default)" : "" }}</mat-radio-button
            >
            <button mat-icon-button (click)="openMasterSuite(enhancementVariant)">
              <mat-icon color="info">info</mat-icon>
            </button>
          </div>
        }
      </mat-radio-group>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="action">
    <button mat-stroked-button (click)="setDefaultEnhancementVariant()">
      Default
    </button>
    <button
      mat-stroked-button
      color="success"
      class="save"
      cdkFocusInitial
      (click)="onSave()"
      [disabled]="!enhancementVariantSelected"
      >
      Save
    </button>
  </mat-dialog-actions>
